import * as http from '../http'
import { buildApiUrl } from './apiUrl'

export function apiGetDocumentTitles() {
  return http.get(buildApiUrl('DocumentTitles'))
}
